import type { CheckedBaggageSummary } from '@eti/schema-types';
import { BaggageStatus } from '@eti/schema-types';

const isCheckedBaggageNotIncluded = (checkedBaggageSummary: CheckedBaggageSummary) => {
  const { tripSummaries } = checkedBaggageSummary;
  if (
    tripSummaries &&
    !(
      tripSummaries[0]?.baggageStatus === BaggageStatus.NoCheckedBaggage ||
      tripSummaries[0]?.baggageStatus === BaggageStatus.NoCheckedBaggageAvailable
    )
  ) {
    return false;
  }
  return true;
};

export default isCheckedBaggageNotIncluded;
